import { html, LitElement } from 'lit';
import { Constructor } from '../types/utils.model';

export declare interface ContainerMixinInterface {
  render(): LitElement['render'];
}

export const ContainerMixin = <T extends Constructor<LitElement>>(Base: T) => {
  class LuaBaseComponent extends Base {
    override render() {
      return html`<slot></slot>`;
    }
  }

  return LuaBaseComponent as Constructor<ContainerMixinInterface> & T;
};
